import { ScrollView, StyleSheet, View } from 'react-native';
import React, { FC, useCallback, useState } from 'react';
import PageTitle from '../../components/PageTitle';
import { Footer } from '../../components/Footer';
import { IFormData } from '../../components/FormHelper/FormHelper.types';
import { InitData } from './types';
import { STYLE_VARS } from '../../constants/style-vars';

import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { ClubServiceLayout } from '../../WebLayout';
import FeedbackForm from './components/FeedbackForm';
import { FONTS } from '../../constants';
import ServicesApi from '../../services/api/services.api';
import { Loading } from '../../components';
import FeedbackPopup from './components/FeedbackPopup';
import { IS_WEB } from '../../constants/platform';
import { useSelector } from 'react-redux';
import { RootState } from '../../services/redux';

const Feedback: FC = () => {
  const { info } = useSelector((redux: RootState) => redux.authReducer);
  const description: string =
    "WE TAKE YOUR FEEDBACK SERIOUSLY AND ITS VERY VALUABLE TO US. PLEASE SUBMIT YOUR FEEDBACK TO THE RELEVANT DEPARTMENT BY FILLING OUT THE FORM BELOW.  WE'LL RESPOND TO YOU AS SOON AS POSSIBLE.  THANK YOU FOR YOUR CONTINUOUS SUPPORT.";
  const initData: InitData = {
    department: undefined,
    location: '',
    file: undefined,
    message: '',
    otherText: '',
  };
  const [isSubmitting, setSubmitting] = useState<boolean>(false);
  const [isOpenModal, setOpenModal] = useState<boolean>(false);
  const isDesktop = useIsDesktop();

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      var formData = new FormData();
      if (data.department === 'other') {
        formData.append('department', data.otherText);
      } else {
        formData.append('department', data.department);
      }
      formData.append('location', data.location);
      if (data.file) {
        formData.append(
          'file',
          IS_WEB
            ? data.file
            : ({
                uri: data.file.uri,
                name: data.file.fileName,
                type: data.file.type,
              } as any)
        );
      }
      formData.append('message', data.message);

      if (info) {
        formData.append('mbname', `${info?.first_name} ${info?.last_name}`);
        formData.append('mbnum', info?.mbnum);
      }
      setSubmitting(true);
      ServicesApi.postFeedback(formData)
        .then((response: any) => {
          setOpenModal(true);
        })
        .catch((error: any) => {
          console.log(error);
        })
        .finally(() => {
          setSubmitting(false);
        });
    },
    [info]
  );

  if (isDesktop()) {
    return (
      <ClubServiceLayout
        title="Feedback"
        current={1}
        icon={require('../../assets/feedback-icon.png')}
        description={description}
      >
        <View>
          <FeedbackForm initData={initData} handleSubmit={handleSubmit} />
        </View>
        {isSubmitting && <Loading isFullScreen={true} />}
        <FeedbackPopup
          isModalVisible={isOpenModal}
          setIsModalVisible={setOpenModal}
        />
      </ClubServiceLayout>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styles.container}>
        <PageTitle
          title="Feedback"
          icon={require('../../assets/feedback-icon.png')}
          haveGoBackButton
          description={description}
        />
      </View>
      <View style={styles.container}>
        <FeedbackForm initData={initData} handleSubmit={handleSubmit} />
      </View>
      <Footer />
      {isSubmitting && <Loading isFullScreen={true} />}
      <FeedbackPopup
        isModalVisible={isOpenModal}
        setIsModalVisible={setOpenModal}
      />
    </ScrollView>
  );
};

export default Feedback;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  input: {
    height: 40,
    paddingHorizontal: 10,
    alignItems: 'flex-start',
    paddingVertical: 10,
    borderWidth: 0.5,
    borderColor: STYLE_VARS.fccDarkGrey,
    color: STYLE_VARS.fccDarkerGrey,
    fontSize: 12,
    letterSpacing: 0.8,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
  },
  titleText: {
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 13,
    fontWeight: '500',
  },
});
